export default __webpack_public_path__ + "static/media/3334 knife block A top.eb42e65c.png";